import { DateTime } from "luxon";

export type StockStatus = "ok" | "expiring" | "expired" | "out";

/** Below this, a batch is worth flagging on the shelf. */
export const EXPIRY_WARNING_DAYS = 7;

export function stockStatus(quantity: number, expiryDate?: string | null): StockStatus {
  if (quantity <= 0) return "out";
  if (!expiryDate) return "ok";

  const days = DateTime.fromISO(expiryDate).diffNow("days").days;
  if (days < 0) return "expired";
  return days <= EXPIRY_WARNING_DAYS ? "expiring" : "ok";
}

/** A delay reads faster than a date when the point is "act now". */
export function expiryLabel(expiryDate?: string | null): string {
  if (!expiryDate) return "—";

  const date = DateTime.fromISO(expiryDate);
  const days = Math.round(date.diffNow("days").days);

  if (days < 0) return "périmé";
  if (days === 0) return "aujourd’hui";
  if (days === 1) return "demain";
  if (days <= EXPIRY_WARNING_DAYS) return `dans ${days} jours`;
  return date.setLocale("fr").toLocaleString(DateTime.DATE_MED);
}
